module.exports = __webpack_public_path__ + "fonts/fa-v4compatibility.fdb652d.woff2";